import React from 'react';
import { Section } from './ui/Section';
export function Problem() {
  return <Section background="gray" data-id="element-92">
      <div className="space-y-6 text-lg text-[#4B5563] leading-relaxed" data-id="element-93">
        <h2 className="text-2xl md:text-3xl font-bold text-[#111827] mb-6" data-id="element-94">
          ¿Te cuesta que se duerman tranquilos?
        </h2>

        <p data-id="element-95">
          Sabemos lo que es. Llega la noche y empieza la lucha. "Mamá, tengo
          miedo", "Papá, dejame la luz prendida". La oscuridad total a veces
          asusta a los más chicos, y eso corta la rutina de sueño que tanto
          costó construir.
        </p>

        <p data-id="element-96">
          No se trata de malcriarlos, se trata de que se sientan seguros. A
          veces, solo necesitan un punto de referencia visual, algo suave que
          los acompañe mientras cierran los ojos, sin que sea una pantalla que
          los desvele más.
        </p>

        <p className="font-medium text-[#111827]" data-id="element-97">
          Crear un ambiente de calma es clave para que descansen (y vos
          también).
        </p>
      </div>
    </Section>;
}